
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.054 2.344a3 3 0 013.892 0l1.271 1.084a1 1 0 00.57.236l1.665.133a3 3 0 012.751 2.751l.133 1.666c.017.21.1.409.236.569l1.084 1.271a3 3 0 010 3.892l-1.084 1.271c-.136.16-.219.36-.236.57l-.133 1.665a3 3 0 01-2.751 2.751l-1.666.133a1 1 0 00-.569.236l-1.271 1.084a3 3 0 01-3.892 0l-1.271-1.084a1 1 0 00-.57-.236l-1.665-.133a3 3 0 01-2.752-2.751l-.132-1.666a1 1 0 00-.236-.569l-1.084-1.271a3 3 0 010-3.892l1.084-1.271a1 1 0 00.236-.57l.132-1.665a3 3 0 012.752-2.751l1.666-.133a1 1 0 00.569-.236l1.271-1.084zM8.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm8.5 5.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-.898-6.86a1 1 0 00-1.537-1.28l-6.666 8a1 1 0 001.536 1.28l6.667-8z"}})])
          )
        }
      }
    